export const JEEmockFaq = [
    {
        targetId: '1',
        heading: '1. What is Invictus Open Test?',
        bulletpoints: [],
        subheading: 'It is self discovery movement for JEE Aspirants to empower themselves with the truth.',
    },
    {
        targetId: '2',
        heading: '2. Who is eligible for Invictus Open Test?',
        bulletpoints: [],
        subheading: 'Students currently studying in the 11th, 12th, or in their drop year who are serious about achieving their goal.',
    },
    {
        targetId: '3',
        heading: '3. What is the registration fee for Invictus Open Test?',
        bulletpoints: [],
        subheading: 'Absolutely free',
    },
    {
        targetId: '4',
        heading: '4. What is the Exam Mode?',
        bulletpoints: [],
        subheading: 'Online Mode',
    },
    {
        targetId: '5',
        heading: '5. What are the dates of the exam?',
        bulletpoints: [],
        subheading: '20th July- JEE Mains Open Test<br/>27th July - JEE Advanced Open Test',
    },
    {
        targetId: '6',
        heading: '6. Can a student appear on both dates?',
        bulletpoints: [],
        subheading: 'Yes, actually, it is highly recommended to take both the tests to get a holistic idea about their preparation status.',
    },
]
